import TeamMemberModel from 'models/TeamMemberModel';

import { updateSearchManager } from './types';

export * from './actions';

const searchManagerReducerObject = {
  [updateSearchManager.request]: (state, action) =>
    state.setIn(
      ['fundingSearchManager', action.fundingSearchId, 'update', 'network', 'loading'],
      true,
    ),
  [updateSearchManager.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(
          ['fundingSearchManager', action.fundingSearchId, 'update', 'network', 'loading'],
          false,
        )
        .setIn(
          ['fundingSearchManager', action.fundingSearchId, 'update', 'network', 'error'],
          false,
        )
        .setIn(
          ['byId', action.fundingSearchId, 'manager'],
          TeamMemberModel.deserialize(action.response),
        ),
    ),
  [updateSearchManager.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(
          ['fundingSearchManager', action.fundingSearchId, 'update', 'network', 'loading'],
          false,
        )
        .setIn(
          ['fundingSearchManager', action.fundingSearchId, 'update', 'network', 'error'],
          action.error,
        ),
    ),
};

export default searchManagerReducerObject;
